// Rim Crew global app
(function(){
  'use strict';
  document.addEventListener('cart:updated', function(e){
    var bubble = document.querySelector('.wm-nav-bubble');
    var count = (e.detail && e.detail.cart && e.detail.cart.item_count) || 0;
    if (count > 0) {
      if (!bubble) {
        var cart = document.querySelector('.wm-nav-cart');
        if (cart) {
          bubble = document.createElement('span');
          bubble.className = 'wm-nav-bubble';
          cart.appendChild(bubble);
        }
      }
      if (bubble) bubble.textContent = count;
    } else if (bubble) {
      bubble.remove();
    }
  });
})();

// burger toggle — UN SEUL listener ici, ne jamais en remettre un dans wm-header.liquid
// (deux listeners basculent la classe deux fois par clic : le menu ne s'ouvre jamais).
(function(){
  var b=document.querySelector('[data-wm-burger]'),m=document.querySelector('[data-wm-mobile-menu]');
  if(!b||!m)return;
  function set(open){
    m.classList.toggle('is-open',open);
    b.classList.toggle('is-active',open);
    b.setAttribute('aria-expanded',open?'true':'false');
    document.body.style.overflow=open?'hidden':'';
  }
  b.addEventListener('click',function(){ set(!m.classList.contains('is-open')); });
  m.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){set(false);})});
  // Echap ferme le menu, et on ne laisse pas le defilement bloque si on repasse en desktop.
  document.addEventListener('keydown',function(e){
    if((e.key==='Escape'||e.key==='Esc') && m.classList.contains('is-open')) set(false);
  });
  window.addEventListener('resize',function(){
    if(window.innerWidth>900 && m.classList.contains('is-open')) set(false);
  });
})();
